<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" center>
    <div style="height: 100px;display: flex;align-items: center;justify-content: center;">
      <el-rate v-model="value" show-text :texts="['极差', '失望', '一般', '满意', '非常满意']"></el-rate>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" style="margin-right: 30px;">取 消</el-button>
      <el-button type='primary' @click="submit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    name: 'star',
    data() {
      return {
        title: '评价',
        dialogVisible: false,
        value: 1,
        row: ''
      }
    },
    methods: {
      show(row) {
        if (row) {
          this.row = row
          this.value = row.service_comment_level || 1
          this.dialogVisible = true
        }
      },
      submit() {
        userInfoAPI.serviceStar({
          service_log_id: this.row.service_log_id,
          comment_id: this.row.service_comment_id,
          comment_level: this.value
        }).then(res => {
          if (res && res.data.code == 0) {
            this.dialogVisible = false
            this.$message.success('评价成功')
            this.$emit('success')
          }
        })
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-rate__text {
    display: block;
    margin-top: 20px;
    text-align: center;
  }

  /deep/ .el-rate__icon {
    font-size: 30px;
  }
</style>
